import '../sass/team.scss';

function closeTeamMemberBio(memberEl) {
    memberEl.classList.remove('team__member--bio-open');
    const toggle = memberEl.querySelector('.js-team-member-bio-toggle');
    if (!toggle) {
        return;
    }
    toggle.setAttribute('aria-expanded', 'false');
    const { labelCollapsed } = toggle.dataset;
    if (labelCollapsed) {
        toggle.setAttribute('aria-label', labelCollapsed);
    }
}

function initTeamBioToggles() {
    document.querySelectorAll('.js-team-member-bio-toggle').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const member = btn.closest('.team__member');
            if (!member) {
                return;
            }
            // Carousel biopies live inside a swiper; the grid clone does not.
            // `swiperEl` is used to update swiper layout, but `scopeEl` is used to close other open bios.
            const swiperEl = member.closest('.js-team-swiper');
            const scopeEl = swiperEl || member.closest('.team');
            const wasOpen = member.classList.contains('team__member--bio-open');

            if (!wasOpen) {
                scopeEl?.querySelectorAll('.team__member--bio-open').forEach((openMember) => {
                    closeTeamMemberBio(openMember);
                });
                member.classList.add('team__member--bio-open');
            } else {
                closeTeamMemberBio(member);
            }

            const isOpen = member.classList.contains('team__member--bio-open');
            btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            const { labelExpanded, labelCollapsed } = btn.dataset;
            if (labelExpanded && labelCollapsed) {
                btn.setAttribute('aria-label', isOpen ? labelExpanded : labelCollapsed);
            }
            const swiper = swiperEl?.swiper;
            if (swiper) {
                requestAnimationFrame(() => {
                    swiper.update();
                });
            }
        });
    });
}

function initTeamSwipers() {
    document.querySelectorAll('.js-team-swiper').forEach((el) => {
        const blockEl = el.closest('.team');
        const prevEl = blockEl?.querySelector('.team__nav-button--prev');
        const nextEl = blockEl?.querySelector('.team__nav-button--next');
        if (!prevEl || !nextEl) {
            return;
        }

        new Swiper(el, {
            loop: false,
            rewind: true,
            roundLengths: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false,
            // },
            allowTouchMove: true,
            simulateTouch: true,
            grabCursor: true,
            navigation: {
                prevEl,
                nextEl,
            }
        });
    });
}

function initTeam() {
    initTeamSwipers();
    initTeamBioToggles();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTeam);
} else {
    initTeam();
}
